module.exports = __webpack_public_path__ + "static/media/GL.86f56559.svg";